import {InformationCircleIcon, XCircleIcon} from "@heroicons/react/24/outline";
import {useAppDispatch, useAppSelector} from "../../stores/store.ts";
import {modalsStateActions} from "../popups/modalsStateSlice.ts";

const EpgPageChannelUnavailableModal = () => {
    const isOpen = useAppSelector(state => state.modalsState.isChannelUnavailableOpen);
    const dispatch = useAppDispatch();
    const handleCloseClick= () => dispatch(modalsStateActions.setIsChannelUnavailableOpen(false));

    return (
        <div
            className={`${isOpen ? "fixed" : "hidden"}  top-0 left-0 w-screen h-screen z-[60] animate-opacityEaseIn`}>
            <div className={"relative w-full h-full flex justify-center items-center"}>
                <div className={"bg-neutral-900/50 absolute top-0 left-0 w-full h-full z-0"}
                     onClick={handleCloseClick}/>
                <div className={"relative max-w-2xl z-10"}>
                    <button
                        className={"absolute right-1 -top-11"}
                        onClick={handleCloseClick}
                    >
                        <XCircleIcon
                            className={
                                "w-9 h-9 text-neutral-200 hover:text-white transition-colors stroke-[1.5]"
                            }
                        />
                    </button>
                    <div className="bg-neutral-700 p-6 rounded-3xl flex items-center space-x-4">
                        <InformationCircleIcon className="w-10 h-10  md:w-7 md:h-7"/>
                        <p className="border-l pl-4">
                            Kanał nie jest dostępny w serwisie Beskid Media GO
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EpgPageChannelUnavailableModal;